module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "学员转移工单",
      "width": "450"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "label-width": 90,
      "label-position": "left",
      "model": _vm.formData,
      "rules": _vm.fromRules
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 20,
      "offset": 1
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.formData.uid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "uid", $$v)
      },
      expression: "formData.uid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 20,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.formData.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "nickname", $$v)
      },
      expression: "formData.nickname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_c('p', {
    staticClass: "thick"
  }, [_vm._v("确认转移学员" + _vm._s(_vm.formData.uid) + "-" + _vm._s(_vm.formData.nickname) + "至学导部门？")])])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("否")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-054fd3b0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/ChangeDirectorModal.vue
// module id = 1600
// module chunks = 8